import app from 'flarum/forum/app';

import {extend} from 'flarum/extend';

import IndexPage from 'flarum/components/IndexPage';
import RajceLinkButton from '../common/components/RajceLinkButton';
import Separator from 'flarum/components/Separator';

export default function () {
  extend(IndexPage.prototype, 'navItems', function (items) {
    items.add(
      'rajceLink',
      <RajceLinkButton active="1"
                       href="https://www.rajce.idnes.cz"
                       icon="fa fa-chevron-left">
        {app.translator.trans('rajce_update.forum.index.rajce_link_button')}
      </RajceLinkButton>,
      106
    );
    items.add('rajceLinkSeparator', Separator.component(), 105);

    return items;
  });
}
